import axios from "axios";

const API_BASE_URL = `${process.env.REACT_APP_SERVICE_URL}`;

export const deleteProfessionalExperience = async (token: any, id: string) => {
  try {
    const response = await axios.delete(
      `${API_BASE_URL}/professionalexperience/${id}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    return response.data;
  } catch (error) {
    console.error("Error deleting Professional Experience:", error);
    throw error;
  }
};

export const deletecertification = async (token: any, id: string) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/certification/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error deleting Professional Experience:", error);
    throw error;
  }
};

export const deleteEducation = async (token: any, id: string) => {
  try {
    const response = await axios.delete(`${API_BASE_URL}/education/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Error deleting Education:", error);
    throw error;
  }
};
